import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=0c8b788a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=0c8b788a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b788a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c8b788a')) {
      api.createRecord('0c8b788a', component.options)
    } else {
      api.reload('0c8b788a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=0c8b788a&scoped=true&", function () {
      api.rerender('0c8b788a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NY7lCxeBbT6/JS/comp/PopupDialog.vue"
export default component.exports